<template>
  <div class="border card h-100 placeholder-card" @click="go">
    <div
      class="placeholder-body card-body d-flex flex-column justify-content-center text-center"
    >
      <router-link :to="resolvedRoute">
        <i
          class="mb-2 text-lg text-secondary"
          :class="`fa fa-${icon}`"
          aria-hidden="true"
        ></i>
        <component :is="title.variant" class="text-secondary">
          {{ title.text }}
        </component>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "PlaceHolderCard",
  props: {
    title: {
      type: Object,
      default: () => ({}),
      variant: {
        validator(value) {
          return ["h1", "h2", "h3", "h4", "h5", "h6"].includes(value);
        },
      },
      text: String,
    },
    icon: {
      type: String,
      default: "plus",
    },
    route: { type: [String, Object], default: null },
  },
  computed: {
    resolvedRoute() {
      if (typeof this.route === "string" && this.route.trim()) {
        return { path: this.route };
      }
      return this.route || null;
    },
  },
  methods: {
    go() {
      if (!this.resolvedRoute) return;
      this.$router.push(this.resolvedRoute);
    },
  },
};
</script>

<style scoped>
.placeholder-card {
  cursor: pointer;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.placeholder-card:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* 회색 배경 + 최소 높이 */
.placeholder-body {
  min-height: 450px; 
  border-radius: 0.5rem;
}
</style>
